import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import EzIconMui from "../EzIconMui/EzIconMui.es.js";
const EzIconFontAwesome = forwardRef(({ icon, ...props }, ref) => {
  const {
    icon: [width, height, _ligatures, _unicode, svgPathData]
  } = icon;
  return /* @__PURE__ */ jsx(EzIconMui, { ref, viewBox: `0 0 ${width} ${height}`, ...props, children: typeof svgPathData === "string" ? /* @__PURE__ */ jsx("path", { d: svgPathData }) : svgPathData.map((d, i) => /* @__PURE__ */ jsx("path", { style: { opacity: i === 0 ? 0.4 : 1 }, d }, d)) });
});
EzIconFontAwesome.displayName = "EzIconFontAwesome";
export {
  EzIconFontAwesome as default
};
//# sourceMappingURL=EzIconFontAwesome.es.js.map
